import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VForm,
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        VStepper,
        {
          model: {
            value: _vm.e1,
            callback: function ($$v) {
              _vm.e1 = $$v
            },
            expression: "e1",
          },
        },
        [
          _c(
            VStepperHeader,
            [
              _c(
                VStepperStep,
                { attrs: { complete: _vm.e1 > 1, step: "1" } },
                [_vm._v(" Seleccione un caso de uso ")]
              ),
              _c(VDivider),
              _c(
                VStepperStep,
                { attrs: { complete: _vm.e1 > 2, step: "2" } },
                [_vm._v(" Listado de tablas ")]
              ),
              _c(VDivider),
              _c(VStepperStep, { attrs: { step: "3" } }, [
                _vm._v(" Configuración de ejecución "),
              ]),
            ],
            1
          ),
          _c(
            VStepperItems,
            [
              _c(
                VStepperContent,
                { attrs: { step: "1" } },
                [
                  _c(
                    VRow,
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "form_attrs_productize_usecase.use_case"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              outlined: _vm.edit,
                              filled: !_vm.edit,
                              "hide-details": "auto",
                              dense: "",
                              items: _vm.items,
                              "item-text": "business_name",
                              "return-object": "",
                              required: "",
                              rules: _vm.rules.selected_use_case,
                              disabled: _vm.isEditing,
                            },
                            on: { change: _vm.triggerSegmentValidation },
                            model: {
                              value: _vm.form.selected_use_case,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "selected_use_case", $$v)
                              },
                              expression: "form.selected_use_case",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "form_attrs_productize_usecase.type_export"
                                  )
                                ) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VSelect, {
                            attrs: {
                              outlined: _vm.edit,
                              filled: !_vm.edit,
                              "hide-details": "auto",
                              dense: "",
                              items: _vm.type_export_items,
                              "item-text": "export_type_name",
                              "return-object": "",
                              rules: _vm.rules.type_export,
                              required: "",
                              disabled: _vm.isEditing,
                            },
                            on: { change: _vm.triggerSegmentValidation },
                            model: {
                              value: _vm.form.type_export,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "type_export", $$v)
                              },
                              expression: "form.type_export",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.form.type_export &&
                                      (_vm.form.type_export.id == 2 ||
                                        _vm.form.type_export.id == 3)
                                      ? "form_attrs_productize_usecase.table_name"
                                      : "form_attrs_productize_usecase.segment"
                                  )
                                ) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VTextField, {
                            ref: "segmentField",
                            staticClass: "pl-0 pl-md-0",
                            attrs: {
                              dense: "",
                              outlined: "",
                              name: "form.segment",
                              required: "",
                              rules: [_vm.rules.segment, _vm.segmentValidation],
                              autocomplete: "off",
                              disabled: _vm.isEditing,
                            },
                            on: { blur: _vm.onSegmentChange },
                            model: {
                              value: _vm.form.segment,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "segment", $$v)
                              },
                              expression: "form.segment",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "2" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    _vm.form.type_export &&
                                      (_vm.form.type_export.id == 2 ||
                                        _vm.form.type_export.id == 3)
                                      ? "form_attrs_productize_usecase.description_table"
                                      : _vm.form.type_export &&
                                        _vm.form.type_export.id == 1
                                      ? "form_attrs_productize_usecase.description_segment"
                                      : "form_attrs_productize_usecase.description"
                                  )
                                ) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "4" } },
                        [
                          _c(VTextarea, {
                            staticClass: "pl-0 pl-md-0",
                            attrs: {
                              dense: "",
                              outlined: "",
                              name: "textarea",
                              rules: _vm.rules.description,
                              required: "",
                              disabled: _vm.isEditing,
                            },
                            model: {
                              value: _vm.form.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "description", $$v)
                              },
                              expression: "form.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCard,
                        {
                          staticClass:
                            "min-w-0 w-full card-bulk pt-2 pb-0 mb-0",
                        },
                        [
                          _c(
                            VCol,
                            {
                              staticClass: "text-center mb-2",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  on: {
                                    dragover: function ($event) {
                                      $event.preventDefault()
                                    },
                                    drop: function ($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "drag-file text-center pt-1 mt-1 pointer",
                                      on: { drop: _vm.dropFile },
                                    },
                                    [
                                      !_vm.hasFile
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column justify-space-between align-center",
                                            },
                                            [
                                              _c(VImg, {
                                                attrs: {
                                                  width: "64px",
                                                  src: require("@/assets/sql_icon.png"),
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      !_vm.hasFile
                                        ? _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "customer_insights.bulk_upload.drag_here"
                                                )
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _c(VFileInput, {
                                        staticClass:
                                          "upload-input-file pointer",
                                        attrs: {
                                          rules: _vm.rules.file,
                                          accept: ".sql,.txt",
                                          chips: "",
                                          placeholder: _vm.$t(
                                            "form_attrs_productize_usecase.attach_file"
                                          ),
                                          "prepend-icon": "",
                                          "show-size": "",
                                          "truncate-length": "35",
                                          solo: "",
                                          flat: "",
                                        },
                                        on: { change: _vm.onFileSelected },
                                        model: {
                                          value: _vm.form.sql_file,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "sql_file", $$v)
                                          },
                                          expression: "form.sql_file",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _vm.form.type_export &&
                              _vm.form.type_export.id == 3
                                ? _c(
                                    VAlert,
                                    {
                                      staticClass: "transparent-bg",
                                      attrs: {
                                        type: "info",
                                        variant: "outlined",
                                        text: "text",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " Al ser del tipo de exportación Base de Ids con variables pasará por un flujo de aprobación. "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VStepperContent,
                { attrs: { step: "2" } },
                [
                  _c(
                    VRow,
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(VDataTable, {
                            key: _vm.keySearchTable,
                            staticClass: "text-center table-inca",
                            attrs: {
                              responsive: "",
                              headers: _vm.headers,
                              items: _vm.tableItems,
                              "hide-default-footer": "",
                              "disable-pagination": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "item.type_table",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    item.type_table === "Tabla Final"
                                      ? _c("div", [
                                          _c("strong", [
                                            _vm._v(_vm._s(item.type_table)),
                                          ]),
                                        ])
                                      : _c("div", [
                                          _vm._v(
                                            " " + _vm._s(item.type_table) + " "
                                          ),
                                        ]),
                                  ]
                                },
                              },
                              {
                                key: "item.table_replace",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    item.type_table === "Tabla INCA" ||
                                    item.type_table === "Tabla Sandbox"
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              VRow,
                                              [
                                                _c(
                                                  VCol,
                                                  {
                                                    staticClass:
                                                      "d-flex align-center",
                                                    attrs: { cols: "4" },
                                                  },
                                                  [
                                                    _c(VCheckbox, {
                                                      staticStyle: {
                                                        "margin-top": "0px",
                                                      },
                                                      attrs: {
                                                        label: "Flag Copiar",
                                                        "hide-details": "",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeCheck(
                                                            item
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: item.flag_copy,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "flag_copy",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.flag_copy",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  VCol,
                                                  {
                                                    staticClass:
                                                      "d-flex align-center",
                                                    attrs: { cols: "8" },
                                                  },
                                                  [
                                                    !item.flag_copy
                                                      ? _c(VAutocomplete, {
                                                          attrs: {
                                                            outlined: "",
                                                            "hide-details":
                                                              "auto",
                                                            dense: "",
                                                            items:
                                                              _vm.viewsData,
                                                            required: "",
                                                            "return-object": "",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.onTableSelected(
                                                                item,
                                                                $event
                                                              )
                                                            },
                                                            "update:search-input":
                                                              _vm.onSearchInput,
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "item",
                                                                fn: function (
                                                                  data
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "d-flex align-center",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            domProps:
                                                                              {
                                                                                innerHTML:
                                                                                  _vm._s(
                                                                                    _vm.highlightText(
                                                                                      data
                                                                                        .item
                                                                                        .text
                                                                                    )
                                                                                  ),
                                                                              },
                                                                          }
                                                                        ),
                                                                        data
                                                                          .item
                                                                          .status ===
                                                                        "APPROVED"
                                                                          ? _c(
                                                                              VChip,
                                                                              {
                                                                                staticClass:
                                                                                  "ml-2",
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "green",
                                                                                    dark: "",
                                                                                    small:
                                                                                      "",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Aprobado "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : data
                                                                              .item
                                                                              .status ===
                                                                            "REVISION"
                                                                          ? _c(
                                                                              VChip,
                                                                              {
                                                                                staticClass:
                                                                                  "ml-2",
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "grey",
                                                                                    dark: "",
                                                                                    small:
                                                                                      "",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " Pendiente "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                              {
                                                                key: "append-outer",
                                                                fn: function () {
                                                                  return [
                                                                    _c(
                                                                      VTooltip,
                                                                      {
                                                                        attrs: {
                                                                          bottom:
                                                                            "",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "activator",
                                                                                fn: function (
                                                                                  ref
                                                                                ) {
                                                                                  var on =
                                                                                    ref.on
                                                                                  var attrs =
                                                                                    ref.attrs
                                                                                  return [
                                                                                    _c(
                                                                                      VIcon,
                                                                                      _vm._g(
                                                                                        _vm._b(
                                                                                          {
                                                                                            staticClass:
                                                                                              "pointer",
                                                                                            on: {
                                                                                              click:
                                                                                                function (
                                                                                                  $event
                                                                                                ) {
                                                                                                  return _vm.$refs.tablesComponent.onOpen(
                                                                                                    item
                                                                                                  )
                                                                                                },
                                                                                            },
                                                                                          },
                                                                                          "v-icon",
                                                                                          attrs,
                                                                                          false
                                                                                        ),
                                                                                        on
                                                                                      ),
                                                                                      [
                                                                                        _vm._v(
                                                                                          " mdi-layers-search "
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            true
                                                                          ),
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "frases.search_table_view"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      VTooltip,
                                                                      {
                                                                        attrs: {
                                                                          bottom:
                                                                            "",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "activator",
                                                                                fn: function (
                                                                                  ref
                                                                                ) {
                                                                                  var on =
                                                                                    ref.on
                                                                                  var attrs =
                                                                                    ref.attrs
                                                                                  return [
                                                                                    _c(
                                                                                      VIcon,
                                                                                      _vm._g(
                                                                                        _vm._b(
                                                                                          {
                                                                                            staticClass:
                                                                                              "pointer",
                                                                                            on: {
                                                                                              click:
                                                                                                _vm.getObjectAccess,
                                                                                            },
                                                                                          },
                                                                                          "v-icon",
                                                                                          attrs,
                                                                                          false
                                                                                        ),
                                                                                        on
                                                                                      ),
                                                                                      [
                                                                                        _vm._v(
                                                                                          "mdi-refresh-circle "
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            true
                                                                          ),
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "frases.update_list"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                                proxy: true,
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                          model: {
                                                            value:
                                                              item.table_Inca,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "table_Inca",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.table_Inca",
                                                          },
                                                        })
                                                      : _c(
                                                          "p",
                                                          {
                                                            staticStyle: {
                                                              "margin-bottom":
                                                                "0px",
                                                            },
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "IMPORTANTE:"
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              " Se realizará una copia de la tabla utilizada en el sandbox la cual no se podrá actualizar. Se recomienda utilizar una tabla publicada en INCA. "
                                                            ),
                                                          ]
                                                        ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _c("div", [
                                          _vm._v(
                                            " " + _vm._s(item.table_Inca) + " "
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _vm.flag_alert
                            ? _c(
                                VAlert,
                                {
                                  staticClass: "transparent-bg",
                                  attrs: {
                                    type: "info",
                                    variant: "outlined",
                                    text: "text",
                                  },
                                },
                                [
                                  _vm._v(
                                    " No se tiene acceso a todas las tablas INCA. Cuando se realicen todas las aprobaciones podrá ejecutar el proceso. "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VStepperContent,
                { attrs: { step: "3" } },
                [
                  _c(
                    VRow,
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(VCol, { attrs: { cols: "12" } }, [
                        _c("p", [_vm._v("Configuración de Ejecución")]),
                      ]),
                      _c(
                        VCol,
                        { attrs: { cols: "12" } },
                        [
                          _c(VSwitch, {
                            attrs: {
                              label: _vm.$t(
                                "form_attrs_productize_usecase.unique_load"
                              ),
                            },
                            on: { change: _vm.ChangeUnique },
                            model: {
                              value: _vm.form.unique_load,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "unique_load", $$v)
                              },
                              expression: "form.unique_load",
                            },
                          }),
                        ],
                        1
                      ),
                      !_vm.form.unique_load
                        ? _c(
                            VCol,
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                VBtnToggle,
                                {
                                  attrs: {
                                    mandatory: "",
                                    dense: "",
                                    outlined: "",
                                  },
                                  model: {
                                    value: _vm.form.buttonSelected,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "buttonSelected", $$v)
                                    },
                                    expression: "form.buttonSelected",
                                  },
                                },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "mr-1 ml-1 custom-btn",
                                      attrs: {
                                        value: "1_DAY",
                                        outlined: true,
                                        dark: true,
                                        rounded: "",
                                        color: "secondary",
                                      },
                                    },
                                    [_vm._v("Diaria ")]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "mr-1 ml-1 custom-btn",
                                      attrs: {
                                        value: "1_WEEK",
                                        outlined: true,
                                        dark: true,
                                        rounded: "",
                                        color: "secondary",
                                      },
                                    },
                                    [_vm._v("Semanal ")]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "mr-1 ml-1 custom-btn",
                                      attrs: {
                                        value: "15_DAY",
                                        outlined: true,
                                        dark: true,
                                        rounded: "",
                                        color: "secondary",
                                      },
                                    },
                                    [_vm._v("Quincenal ")]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "mr-1 ml-1 custom-btn",
                                      attrs: {
                                        value: "1_MONTH",
                                        outlined: true,
                                        dark: true,
                                        rounded: "",
                                        color: "secondary",
                                      },
                                    },
                                    [_vm._v("Mensual ")]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "mr-1 ml-1 custom-btn",
                                      attrs: {
                                        value: "6_MONTH",
                                        outlined: true,
                                        dark: true,
                                        rounded: "",
                                        color: "secondary",
                                      },
                                    },
                                    [_vm._v("Semestral ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.buttonSelected === "1_WEEK" &&
                      !_vm.form.unique_load
                        ? _c(
                            VCol,
                            { staticClass: "mt-2", attrs: { cols: "3" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v("Selecciona un día de la semana")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.buttonSelected === "1_WEEK" &&
                      !_vm.form.unique_load
                        ? _c(
                            VCol,
                            { attrs: { cols: "3" } },
                            [
                              _vm.form.buttonSelected === "1_WEEK" &&
                              !_vm.form.unique_load
                                ? _c(VSelect, {
                                    staticClass: "mt-2",
                                    attrs: {
                                      items: _vm.weekDaysList,
                                      outlined: "",
                                      dense: "",
                                      "item-text": "text",
                                      "item-value": "value",
                                    },
                                    model: {
                                      value: _vm.form.week_day,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "week_day", $$v)
                                      },
                                      expression: "form.week_day",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.buttonSelected === "1_MONTH" &&
                      !_vm.form.unique_load
                        ? _c(
                            VCol,
                            { staticClass: "mt-2", attrs: { cols: "3" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v("Ingrese un número entre 1 y 28")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.buttonSelected === "1_MONTH" &&
                      !_vm.form.unique_load
                        ? _c(
                            VCol,
                            { attrs: { cols: "3" } },
                            [
                              _vm.form.buttonSelected === "1_MONTH" &&
                              !_vm.form.unique_load
                                ? _c(VTextField, {
                                    staticClass: "mt-2",
                                    attrs: {
                                      filled: "",
                                      dense: "",
                                      outlined: "",
                                      rules: _vm.form.numberRules,
                                      type: "number",
                                      autocomplete: "off",
                                    },
                                    model: {
                                      value: _vm.form.number_day,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "number_day", $$v)
                                      },
                                      expression: "form.number_day",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.form.unique_load
                        ? _c(
                            VCol,
                            { staticClass: "mt-2 ml-1", attrs: { cols: "3" } },
                            [
                              _c(
                                VMenu,
                                {
                                  attrs: {
                                    "nudge-right": 40,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "290px",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VTextField,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      "append-icon": "event",
                                                      readonly: "",
                                                      dense: "",
                                                      outlined: "",
                                                      "hide-details": "auto",
                                                      label:
                                                        "Fecha fin de ejecución",
                                                    },
                                                    on: {
                                                      "click:append": on.click,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form
                                                          .end_execution_date,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "end_execution_date",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.end_execution_date",
                                                    },
                                                  },
                                                  "v-text-field",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3208621295
                                  ),
                                  model: {
                                    value: _vm.menu_end_date,
                                    callback: function ($$v) {
                                      _vm.menu_end_date = $$v
                                    },
                                    expression: "menu_end_date",
                                  },
                                },
                                [
                                  _c(VDatePicker, {
                                    attrs: { scrollabel: "" },
                                    model: {
                                      value: _vm.form.end_execution_date,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "end_execution_date",
                                          $$v
                                        )
                                      },
                                      expression: "form.end_execution_date",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("segment-tables-component", {
        ref: "tablesComponent",
        attrs: { "is-productivize": true, "productivize-info": _vm.form },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }